import React from 'react';

import { BillingCycle } from '$/GraphQL/schema/schema';
import { ProductForAdminFragment, ProductType } from '$/GraphQL/schema/types';

import { getListComponent as getAdditionalRegistrantsListComponent } from '../AdditionalRegistrantsListComponent';
import { AddOn } from './AddOn';

export class AdditionalRegistrants extends AddOn {
  public get type(): ProductType {
    return ProductType.AdditionalRegistrants;
  }

  public get isUnsubscribed(): boolean {
    return false;
  }

  public get scheduledQuantity(): number {
    return (this.product as ProductForAdminFragment).scheduledQuantity ?? this.quantity;
  }

  public calculatePrice(billingCycle: BillingCycle, quantity: number): number {
    const noOfPackage = Math.ceil(quantity / 1000);
    switch (billingCycle) {
      case BillingCycle.Month:
        return (this.priceTier?.monthlyPrice ?? 0) * noOfPackage;
      case BillingCycle.Year:
        return (this.priceTier?.annualPrice ?? 0) * noOfPackage;
    }
  }

  public get noOfPackage(): number {
    return Math.ceil(this.quantity / 1000);
  }

  public get nextNoOfPackage(): number {
    return Math.ceil(this.scheduledQuantity / 1000);
  }

  public get prices(): {
    monthly: number;
    annual: number;
    annualByMonth: number;
  } {
    return {
      monthly: (this.priceTier?.monthlyPrice ?? 0) * this.noOfPackage,
      annual: (this.priceTier?.annualPrice ?? 0) * this.noOfPackage,
      annualByMonth: (this.priceTier?.annualPricePerMonth ?? 0) * this.noOfPackage,
    };
  }

  public get nextPrices(): {
    monthly: number;
    annual: number;
    annualByMonth: number;
  } {
    return {
      monthly: (this.nextPriceTier?.monthlyPrice ?? 0) * this.nextNoOfPackage,
      annual: (this.nextPriceTier?.annualPrice ?? 0) * this.nextNoOfPackage,
      annualByMonth: (this.nextPriceTier?.annualPricePerMonth ?? 0) * this.nextNoOfPackage,
    };
  }

  public get ListComponent(): React.FC {
    return getAdditionalRegistrantsListComponent(this);
  }
}
